<ion-app>
  <ion-split-pane
    contentId="main-content"
    [when]="!isMobile ? '(min-width: 0px)' : false"
  >
    <!-- SIDE MENU -->
    <ion-menu
      menuId="main"
      side="start"
      contentId="main-content"
      *ngIf="profileUser && showMenu"
      [swipeGesture]="true"
      [type]="isMobile ? 'overlay' : 'reveal'"
      class="side-menu"
      [ngClass]="{ collapsed: isMenuCollapsed && !isMobile }"
    >
      <ion-header class="sidebar-header">
        <!-- Sidebar Profile Card -->
        <div class="sidebar-profile-card" [ngClass]="{ collapsed: isMenuCollapsed && !isMobile }">
          <div class="profile-avatar-container">
            <img
              [src]="getProfileImage()"
              (error)="onImageError($event)"
              alt="Profile"
              class="profile-avatar"
            />
            <span class="status-dot online"></span>
          </div>
          <div class="profile-details" *ngIf="!isMenuCollapsed || isMobile">
            <span class="profile-name">{{ profileUser?.firstName }} {{ profileUser?.lastName }}</span>
            <span class="profile-role">{{ profileSubtitle }}</span>
          </div>
        </div>
      </ion-header>

      <ion-content>
        <!-- MENÜ YÜKLEME İSKELETİ -->
        <div class="menu-skeleton" *ngIf="menuLoading">
          <div class="skeleton-item" *ngFor="let i of [1,2,3,4,5,6]">
            <div class="skeleton-icon"></div>
            <div class="skeleton-text"></div>
          </div>
        </div>

        <!-- DARALTILMIŞ MENÜ: Sadece ikonlar -->
        <div class="collapsed-menu" *ngIf="isMenuCollapsed && !isMobile && !menuLoading">
          <div
            class="collapsed-menu-item"
            *ngFor="let item of menuItems"
            [class.active]="isActive(item.route)"
            (click)="onCollapsedMenuItemClick(item)"
            [title]="item.text | translate"
          >
            <ion-icon [name]="item.icon"></ion-icon>
            <span class="menu-badge" *ngIf="item.badge">{{ item.badge }}</span>
          </div>
        </div>

        <!-- GENİŞLETİLMİŞ MENÜ: DevExtreme Tree View -->
        <div
          class="dx-tree-view-container"
          *ngIf="(!isMenuCollapsed || isMobile) && !menuLoading"
        >
          <dx-tree-view
            [dataSource]="menuItems"
            selectionMode="single"
            [selectByClick]="true"
            (onItemSelectionChanged)="onTreeViewSelectionChanged($event)"
            itemTemplate="menu-item-template"
            class="dx-menu-tree-view"
            [searchEnabled]="true"
            [searchEditorOptions]="{ placeholder: '', showClearButton: true, label: '', labelMode: 'hidden' }"
            [searchExpr]="['text', 'description']"
            [expandEvent]="'click'"
          >
            <div *dxTemplate="let item of 'menu-item-template'">
              <div
                class="menu-item-content"
                [class.active]="isActive(item.route)"
                [class.coming-soon-item]="item.comingSoon"
              >
                <div class="menu-text-container">
                  <span class="menu-text">
                    <ion-icon [name]="item.icon"></ion-icon>
                    {{ item.text | translate }}
                  </span>
                  <span
                    *ngIf="item.badge"
                    class="menu-badge"
                    [class]="'badge-' + item.badge.toLowerCase()"
                  >
                    {{ item.badge }}
                  </span>
                  <span *ngIf="item.comingSoon" class="menu-badge badge-coming-soon">
                    <ion-icon name="lock-closed-outline" style="font-size:10px;vertical-align:middle;margin-right:2px;"></ion-icon>Kilitli
                  </span>
                </div>
              </div>
            </div>
          </dx-tree-view>
        </div>
      </ion-content>

      <!-- MOBILE MENU CONTROLS -->
      <div class="mobile-menu-controls" *ngIf="isMobile">
        <!-- Settings and Notifications Buttons -->
        <div class="mobile-button-row">
          <div class="mobile-icon-button">
            <ion-icon name="settings-outline"></ion-icon>
          </div>
          <div class="mobile-icon-button">
            <ion-icon name="notifications-outline"></ion-icon>
          </div>
        </div>
      </div>

      <ion-footer class="version-footer" *ngIf="!isMenuCollapsed || isMobile">
        <ion-toolbar>
          <div class="version-container">
            <!-- Language Selector Only -->
            <div class="footer-language-selector">
              <ion-select
                [(ngModel)]="selectedLanguage"
                (ionChange)="changeLanguage($event.detail.value)"
                interface="popover"
              >
                <ion-select-option
                  *ngFor="let lang of translate.getLangs()"
                  [value]="lang"
                >
                  {{ lang | uppercase }}
                </ion-select-option>
              </ion-select>
            </div>
          </div>
        </ion-toolbar>
      </ion-footer>
    </ion-menu>

    <!-- MAIN CONTENT WITH HEADER -->
    <div id="main-content" class="main-content">
      <!-- UNIFIED HEADER -->
      <ion-header *ngIf="profileUser && showMenu">
        <div class="topbar-container">
          <!-- Menu Toggle -->
          <button class="menu-toggle" (click)="toggleSidebar()" aria-label="Menüyü aç/kapat">
            <ion-icon name="menu-outline"></ion-icon>
          </button>

          <!-- Logo -->
          <div class="topbar-brand">
            <img src="assets/icon/heralpbi.svg" alt="HeralpBI" class="logo" />
          </div>

          <!-- Separator -->
          <div class="topbar-divider"></div>

          <!-- Navigation -->
          <nav class="topbar-nav" *ngIf="!isMobile">
            <a routerLink="/dashboard-grid" routerLinkActive="active" class="nav-item">
              <ion-icon name="grid-outline"></ion-icon>
              <span>{{ "layout.dashboard" | translate }}</span>
            </a>
            <a routerLink="/report-gallery" routerLinkActive="active" class="nav-item">
              <ion-icon name="document-text-outline"></ion-icon>
              <span>{{ "layout.reports" | translate }}</span>
            </a>
          </nav>

          <!-- Spacer -->
          <div class="topbar-spacer"></div>

          <!-- Search (optional) -->
          <div class="topbar-search" *ngIf="showSearchbar && !isMobile">
            <ion-searchbar
              class="searchbar-desktop"
              placeholder="Ara..."
              (ionInput)="onSearch($event)"
            ></ion-searchbar>
          </div>

          <!-- Actions -->
          <div class="topbar-actions" *ngIf="!isMobile">
            <button class="action-btn" title="Ayarlar">
              <ion-icon name="settings-outline"></ion-icon>
            </button>
            <button class="action-btn" title="Bildirimler">
              <ion-icon name="notifications-outline"></ion-icon>
            </button>
          </div>

          <!-- Profile -->
          <div class="topbar-profile" (click)="toggleProfileMenu()">
            <img
              [src]="getProfileImage()"
              (error)="onImageError($event)"
              alt="Profile"
            />
          </div>
        </div>
      </ion-header>

      <!-- PROFILE DROPDOWN MENU -->
      <div class="submenu-wrapper" [ngClass]="{ openMenu: isProfileMenuOpen }">
        <div class="submenu">
          <div
            class="mobile-username"
            *ngIf="isMobile && isProfileMenuOpen && profileUser"
          >
            <p>
              {{ "topbar.welcome" | translate }},
              <b>{{ profileUser.firstName }}</b>
            </p>
          </div>
          <ion-item
            *ngFor="let item of profileMenuItems"
            (click)="handleMenuItemClick(item)"
          >
            <ion-icon [name]="item.icon"></ion-icon>
            <ion-label>{{ item.label | translate }}</ion-label>
          </ion-item>

          <!-- THEME SELECTOR IN PROFILE MENU -->
          <div class="submenu-theme-selector">
             <div class="submenu-section-label">{{ 'themeSelect' | translate }}</div>
            <ion-select
              [value]="selectedTheme?.id"
              (ionChange)="changeTheme($event.detail.value)"
              interface="popover"
              class="submenu-theme-select"
            >
              <ion-select-option
                *ngFor="let theme of availableThemes"
                [value]="theme.id"
              >
                🎨 {{ ('theme.' + theme.id) | translate }}
              </ion-select-option>
            </ion-select>
          </div>
        </div>
      </div>

      <!-- ROUTER OUTLET -->
      <ion-content>
        <ion-router-outlet></ion-router-outlet>
      </ion-content>
    </div>
  </ion-split-pane>
</ion-app>
